module.exports = __webpack_public_path__ + "static/img/a3.798e6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a3.png
// module id = J2a/
// module chunks = 1